import { useGLTF } from "@react-three/drei"
import { Suspense, useRef, useEffect } from "react"
import * as THREE from "three"

const LoadModel = ({ name, url, visible, shouldBloom = false}) => {
  const model = useGLTF(url)
  const groupRef = useRef()

  useEffect(() => {
    if (groupRef.current && shouldBloom) {
      groupRef.current.traverse((obj) => {
        if (obj.isMesh) {
          obj.layers.enable(1)
          // Optional: enhance bloom effect with emissive
        //   if (obj.material) {
        //     obj.material.emissive = new THREE.Color(0xffff99)
        //     obj.material.emissiveIntensity = 2
        //   }
        }
      })
    }
  }, [shouldBloom])

  return (
    <Suspense fallback={null} key={name}>
      {visible && <primitive object={model.scene} ref={groupRef} />}
    </Suspense>
  )
}

export default LoadModel
